import { useTranslations } from 'next-intl'
import {
  StackProps,
  useColorModeValue,
  Heading,
  Text,
  Flex,
  Image,
  HStack,
  Button,
  Box,
} from '@chakra-ui/react'
import { FACILITY_PLACEHOLDER } from '@/constants'
import { IFacilityNode } from '@/types/facilities.interface'
import NextLink from 'next/link'
import { Flag } from '@/components/Flag'
import { getImages } from '@/utils/getImages'

interface Types extends StackProps {
  facility: IFacilityNode
}

export function FacilityCard({ facility }: Types) {
  const t = useTranslations()
  const {
    facilitiesName,
    countryName,
    facilityAvailability,
    facilitiesId,
    countryCode,
    facilitiesImagesCsvPrioritized,
    // facilitiesPricePerKwh,
  } = facility

  const { mainImage } = getImages(
    facilitiesImagesCsvPrioritized,
    FACILITY_PLACEHOLDER
  )

  // const price = formatPrice(Number(facilitiesPricePerKwh))

  return (
    <Box
      bg={useColorModeValue('white', 'gray.700')}
      w="full"
      shadow="md"
      _hover={{ shadow: 'lg' }}
      rounded="4px"
      textAlign="left"
      transition="all .5s ease"
      h={'max-content'}
    >
      <Image
        src={mainImage}
        alt={facilitiesName}
        roundedTop={'xl'}
        fallbackSrc={FACILITY_PLACEHOLDER}
      />
      <Flex
        px={4}
        mt={4}
        wrap={'wrap'}
        gap={2}
        direction={'row'}
        align={'center'}
      >
        <Flag countryCode={countryCode} />
        <Heading as={'h3'} fontSize={'2xl'} flex={1} fontWeight={'semibold'}>
          {`${facilitiesName}, ${countryName}`}
        </Heading>
      </Flex>
      {facilityAvailability === 'available' && (
        <HStack
          paddingLeft={4}
          color={'green.450'}
          fontSize={'sm'}
          mt={2}
          mb={4}
        >
          <Text>{t('facilities-list.units-available')}</Text>
        </HStack>
      )}
      {facilityAvailability === 'coming_soon' && (
        <HStack
          paddingLeft={4}
          color={'orange.450'}
          fontSize={'sm'}
          mt={2}
          mb={4}
        >
          <Text>{t('facilities-list.coming-soon')}</Text>
        </HStack>
      )}
      {facilityAvailability === 'fully_booked' && (
        <HStack paddingLeft={4} color={'red.550'} fontSize={'sm'} mt={2} mb={4}>
          <Text>{t('facilities-list.fully-booked')}</Text>
        </HStack>
      )}
      <Box my={6} px={4} textAlign={'center'}>
        <NextLink href={`facilities/${facilitiesId}`} passHref>
          <Button w={'full'} size={'sm'} as={'a'} variant="black" py={6}>
            {t('facilities-list.view-farm')}
          </Button>
        </NextLink>
      </Box>
    </Box>
  )
}
